import React, { useState } from "react";
import {
  Collapse,
  IconButton,
  Typography,
  Card,
  CardHeader,
  CardContent,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ConditionalityInfo from "pages/Monitoring/History/conditionalityInfo";

const CollapsibleSection = ({
  title,
  children,
  conditionalities = [],
  isConditionalityHistory = false,
}) => {
  const [open, setOpen] = useState(false);

  const handleToggle = () => {
    setOpen((prev) => !prev);
  };

  const getCardContent = () => {
    if (isConditionalityHistory) {
      return (
        conditionalities.map((c, idx) => (
          <ConditionalityInfo conditionality={c} key={idx} />
        ))
      );
    }

    return children;
  }

  return (
    <Card>
      <CardHeader
        onClick={handleToggle}
        action={
          <IconButton aria-label={open ? "Recolher" : "Expandir"} aria-expanded={open}>
            <ExpandMoreIcon
              sx={{
                transform: open ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.3s",
              }}
            />
          </IconButton>
        }
        title={
          <Typography
            variant="h6"
            style={{ fontFamily: "Poppins", fontSize: "16px" }}
          >
            {title}
          </Typography>
        }
        style={{ cursor: "pointer" }}
      />
      <Collapse in={open} timeout="auto" unmountOnExit>
        <CardContent>
          {getCardContent()}
        </CardContent>
      </Collapse>
    </Card>
  );
};

export default CollapsibleSection;
